import { render, staticRenderFns } from "./communityFundManageList.vue?vue&type=template&id=45aa077c&scoped=true"
import script from "./communityFundManageList.vue?vue&type=script&lang=js"
export * from "./communityFundManageList.vue?vue&type=script&lang=js"
import style0 from "./communityFundManageList.vue?vue&type=style&index=0&id=45aa077c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa077c",
  null
  
)

export default component.exports